import Vue from "vue"
import router from "@/router"

export default {
  namespaced: true,
  state: {
    expires: localStorage.getItem("expires") || "",
    message: "",
    user: {}
  },
  getters: {
    isAuthenticated: (state) => {
      return window.moment().isBefore(state.expires)
    },
    getUserDetails: (state) => {
      return state.user
    },
    isAdmin: (state) => {
      return !!state.user.roles.find(role => role.name === "administrator")
    }
  },
  mutations: {
    SET_EXPIRATION: (state, value) => {
      let expires = window.moment().add(value.expires_at, "seconds").format("YYYY-MM-DD HH:mm:ss")
      state.expires = expires
      localStorage.setItem("expires", expires)
    },
    SET_USER_DETAILS: (state, value) => {
      Vue.set(state, "user", value)
      Vue.set(state.user, "permissions", value.permissions.map(e => e.name))
      router.currentRoute.meta.beforeEnter(router.currentRoute, router.currentRoute, route => {
        if (route) router.push(route)
      })
    },
    CLEAR_USER_DETAILS: (state) => {
      state.user = {}
      state.expires = ""
      localStorage.removeItem("expires")
    }
  },
  actions: {
    init: ({ state, dispatch }) => {
      dispatch("getUser")
      /**
       * Basic auth check
       */
      if (window.moment().isAfter(state.expires)) {
        dispatch("logout")
        return false
      }
    },
    login: async ({ commit, dispatch }, credentials) => {
      try {
        let promise = await window.axios.post("/auth/login", credentials)
        commit("SET_EXPIRATION", promise.data)
        commit("SET_USER_DETAILS", promise.data)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    logout ({ commit, state }) {
      if (state.expires && window.moment().isBefore(state.expires)) {
        window.axios.get("/auth/logout")
      }
      commit("CLEAR_USER_DETAILS")
    },
    getUser: async ({ commit, state, dispatch }) => {
      try {
        let promise = await window.axios.get("/auth/user")
        commit("SET_USER_DETAILS", promise.data)
        commit("SET_EXPIRATION", promise.data)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    updateUserDetails: async ({ commit, dispatch }, payload) => {
      try {
        let promise = await window.axios.post("/auth/updateUserDetails", payload)
        dispatch("getUser")
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    changeUserPassword: async ({ commit }, payload) => {
      try {
        let promise = await window.axios.post("/auth/changeUserPassword", payload)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    forgotPassword: async ({ commit }, payload) => {
      try {
        let promise = await window.axios.post("/password/create", payload)
        return promise
      } catch (error) {
        return { ...error.response }
      }
    },
    findToken: async ({ commit }, token) => {
      try {
        let promise = await window.axios.get("/password/find/" + token)
        return promise
      } catch (error) {
        return { ...error.response }
      }
    },
    resetPassword: async ({ commit }, payload) => {
      try {
        let promise = await window.axios.post("/password/reset", payload)
        return promise
      } catch (error) {
        return { ...error.response }
      }
    }
  }
}
